import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=3f3660cf&lang=pug&"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WelcomeMessage.vue"
export default component.exports